export enum EScene {
  INIT = 'init',
  ERROR = 'error',
  PRE_LOBBY = 'pre_lobby',
  LOBBY = 'lobby',
  STARTED_COUNTDOWN = 'started_countdown',
  STARTED = 'started',
  ENDED = 'ended',
  SCOREBOARD = 'scoreboard',
}
